import { ActionTypes } from "../../constants/ActionTypes";
import {
    IInstancePrarams,
    IDeleteLetterArgs,
    IRestoreLetterArgs,
    IRouteHistory,
    IClearList
} from "../../interfaces/Instance";

export const onRouteHistory = (params: IRouteHistory) => {
    return {
        type: ActionTypes.ROUTE_HISTORY,
        payload: params,
    };
};

export const onClearListInstance = () => {
    return {
        type: ActionTypes.CLEAR_LIST_INSTANCE,
    };
};

export const onGetInstance = (params: IInstancePrarams) => {
    return {
        type: ActionTypes.GET_LIST_INSTANCE,
        payload: params,
    };
};

export const fetchInstanceSuccess = (instance: any) => {
    return {
        type: ActionTypes.FETCH_LIST_INSTANCE_SUCCESS,
        payload: instance,
    };
};

export const onDeleteRefer = (args: IDeleteLetterArgs) => {
    return {
        type: ActionTypes.DELETE_REFER,
        payload: args,
    };
};

export const DeleteReferSuccess = () => {
    return {
        type: ActionTypes.DELETE_REFER_SUCCESS,
    };
};

export const onRestoreLetter = (args: IRestoreLetterArgs) => {
    return {
        type: ActionTypes.RESTORE_LETTER,
        payload: args,
    };
};

export const RestoreLetterSuccess = () => {
    return {
        type: ActionTypes.RESTORE_LETTER_SUCCESS,
    };
};
